import { Layers, ClipboardList, UploadCloud, MapPin, Users, History, Calendar, Route, Zap, Bell, Shield, Phone, FileSignature, FileText, Mail } from "lucide-react";

const features = [
  {
    icon: <Layers className="text-blue-600" size={24} />,
    title: "Arborescence de pages modulable",
    description: "Créez et organisez vos pages et sous-pages librement selon vos processus métier."
  },
  {
    icon: <ClipboardList className="text-blue-600" size={24} />,
    title: "Formulaires personnalisables",
    description: "Construisez des formulaires sur-mesure pour collecter les données essentielles à votre activité."
  },
  {
    icon: <UploadCloud className="text-blue-600" size={24} />,
    title: "Importation de documents",
    description: "Importez et centralisez facilement vos devis, contrats et autres documents."
  },
  {
    icon: <MapPin className="text-blue-600" size={24} />,
    title: "Autocomplétion des adresses",
    description: "Gagnez du temps avec la saisie automatique des adresses et réduisez les erreurs."
  },
  {
    icon: <Users className="text-blue-600" size={24} />,
    title: "Gestion des utilisateurs et des rôles",
    description: "Ajoutez des utilisateurs et attribuez des rôles pour contrôler les accès et responsabilités."
  },
  {
    icon: <History className="text-blue-600" size={24} />,
    title: "Historique des modifications",
    description: "Suivez toutes les actions effectuées dans votre CRM pour une traçabilité optimale."
  },
  {
    icon: <Calendar className="text-blue-600" size={24} />,
    title: "Planning partagé",
    description: "Coordonnez les emplois du temps de votre équipe depuis un espace centralisé."
  },
  {
    icon: <Route className="text-blue-600" size={24} />,
    title: "Calcul d’itinéraires",
    description: "Optimisez vos déplacements grâce au calcul automatique des distances entre rendez-vous."
  },
  {
    icon: <History className="text-blue-600" size={24} />,
    title: "Historique des rendez-vous",
    description: "Consultez l’historique complet de vos interactions et rendez-vous client."
  },
  {
    icon: <Zap className="text-blue-600" size={24} />,
    title: "Automatisation des actions",
    description: "Simplifiez vos tâches répétitives grâce à des règles d’automatisation."
  },
  {
    icon: <Bell className="text-blue-600" size={24} />,
    title: "Notifications en temps réel",
    description: "Recevez des alertes instantanées sur les actions importantes de votre CRM."
  },
  // {
  //   icon: <File className="text-blue-600" size={24} />,
  //   title: "Génération de documents PDF",
  //   description: "Créez et exportez des devis, rapports et documents PDF personnalisés."
  // },
  // {
  //   icon: <FileText className="text-blue-600" size={24} />,
  //   title: "Devis et factures",
  //   description: "Générez rapidement devis et factures adaptés à vos clients, avec un suivi centralisé."
  // },
  // {
	// 	icon: <Rocket className="text-blue-600" size={24} />,
  //   title: "Accès aux fonctionnalités à venir",
  //   description: "Bénéficiez en avant-première des futures innovations et mises à jour."
  // },
	{
    icon: <FileText className="text-blue-600" size={24} />,
    title: "Génération de documents PDF",
    description: "Créez automatiquement des documents PDF pré-remplis avec les informations de vos clients."
  },
  {
    icon: <FileSignature className="text-blue-600" size={24} />,
    title: "Signature électronique",
		description: "Envoyez vos documents et suivez visuellement leur parcours en temps réel jusqu’à signature."
  },
  {
    icon: <Mail className="text-blue-600" size={24} />,
    title: "Envoi de mails et campagnes",
    description: "Envoyez des mails personnalisés avec des templates incluant les informations de vos clients."
  },
  {
		icon: <Phone className="text-blue-600" size={24} />,
    title: "Support prioritaire",
    description: "Accédez à notre assistance prioritaire pour un accompagnement réactif et personnalisé."
  },
	{
		icon: <Shield className="text-blue-600" size={24} />,
		title: "Sécurité",
		description: "Vos données sont protégées selon les normes RGPD et les standards de sécurité les plus stricts."
	},
];

export function Features() {
  // const features = [
  //   {
  //     icon: <LineChart className="text-blue-600" size={24} />,
  //     title: "Tableau de bord",
  //     description: "Visualisez vos données et prenez des décisions éclairées"
  //   },
  //   {
  //     icon: <Users className="text-blue-600" size={24} />,
  //     title: "Gestion des contacts",
  //     description: "La gestion des contacts dans un EvisonCRM consiste à centraliser, organiser et suivre toutes les informations relatives aux clients, prospects et partenaires afin de faciliter les interactions"
  //   },
  //   {
  //     icon: <FileText className="text-blue-600" size={24} />,
  //     title: "Devis et factures",
  //     description: "Permet de créer facilement des devis et factures personnalisés pour vos clients, adaptés à leurs besoins, tout en centralisant leur suivi."
  //   },
  //   // {
  //   //   icon: <Mail className="text-blue-600" size={24} />,
  //   //   title: "Emails",
  //   //   description: "Communiquez efficacement avec vos clients"
  //   // },
  //   // {
  //   //   icon: <PhoneCall className="text-blue-600" size={24} />,
  //   //   title: "Suivi d'appels",
  //   //   description: "Gardez une trace de vos échanges"
  //   // },
  //   {
  //     icon: <Calendar className="text-blue-600" size={24} />,
  //     title: "Planning",
  //     description: "EvisonCRM avec gestion de planning vous permet de gérer simultanément plusieurs types de plannings, de calculer automatiquement les distances entre les rendez-vous et ainsi de gagner un temps précieux."
  //   },
  //   {
  //     icon: <Settings className="text-blue-600" size={24} />,
  //     title: "Personnalisation",
  //     description: "Le CRM est 100% personnalisable, offrant une flexibilité totale pour s’adapter à vos besoins spécifiques, vos processus et votre manière de travailler, dans tous les aspects possibles"
  //   },
  //   {
  //     icon: <Shield className="text-blue-600" size={24} />,
  //     title: "Sécurité",
  //     description: "Le CRM est hautement sécurisé et entièrement conforme à la loi RGPD, garantissant la protection et la confidentialité de vos données selon les normes légales les plus strictes."
  //   }
  // ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Toutes les fonctionnalités dont vous avez besoin
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une solution complète pour gérer votre activité commerciale
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="p-6 border border-gray-200 rounded-xl hover:shadow-lg transition-shadow">
              <div className="bg-blue-50 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}